import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import loginData from "../login.json";
import icLogo from "../images/ic.png";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    // Simulate loading for better UX
    setTimeout(() => {
      // Find user in login.json
      const user = loginData.find(
        (u) => u.email === email && u.password === password
      );

      if (user) {
        // Store user data temporarily for PIN verification
        sessionStorage.setItem("pendingAuth", JSON.stringify({
          email: user.email,
          name: user.name,
          pin: user.pin
        }));
        navigate("/verify-pin");
      } else {
        setError("Invalid email or password");
        setIsLoading(false);
      }
    }, 800);
  };

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px 16px",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      position: "relative",
      overflow: "hidden"
    }}>
      {/* Animated background shapes */}
      <div style={{
        position: "absolute",
        width: "400px",
        height: "400px",
        background: "rgba(255, 255, 255, 0.1)",
        borderRadius: "50%",
        top: "-200px",
        left: "-200px",
        animation: "float 6s ease-in-out infinite"
      }}></div>
      <div style={{
        position: "absolute",
        width: "300px",
        height: "300px",
        background: "rgba(255, 255, 255, 0.08)",
        borderRadius: "50%",
        bottom: "-150px",
        right: "-150px",
        animation: "float 8s ease-in-out infinite reverse"
      }}></div>

      <div style={{ width: "100%", maxWidth: "420px", margin: "0 auto", position: "relative", zIndex: 1 }}>
        <div style={{
          background: "rgba(255, 255, 255, 0.98)",
          padding: "clamp(28px, 4vw, 44px)",
          borderRadius: "20px",
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.3)"
        }}>
          {/* Logo/Icon */}
          <div style={{
            textAlign: "center",
            marginBottom: "20px"
          }}>
            <div style={{
              width: "150px",
              height: "100px",
              margin: "0 auto 20px",
              background: "transparent",
              borderRadius: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "none",
              fontSize: "40px",
              fontWeight: "bold",
              color: "white"
            }}>
              <img
                src={icLogo}
                alt="Infinnity Capital"
                style={{
                  width: "200px",
                  height: "206px",
                  objectFit: "contain"
                }}
              />
            </div>
          </div>

          <h2 style={{
            textAlign: "center",
            marginBottom: "10px",
            background: "linear-gradient(135deg, #FFD700, #FFA500)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: "bold",
            fontSize: "clamp(24px, 4vw, 32px)",
            lineHeight: "1.25",
            letterSpacing: "0.3px"
          }}>
             Mint Platform
          </h2>
          <p style={{ 
            textAlign: "center", 
            marginBottom: "32px", 
            color: "#666",
            fontSize: "15px",
            fontWeight: "500"
          }}>
            Secure Admin Sign In
          </p>
          
          <Form onSubmit={handleLogin}>
            <Form.Group className="mb-4">
              <Form.Label style={{ 
                fontWeight: "600", 
                color: "#333",
                marginBottom: "10px"
              }}>
                Email Address
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="admin@infinnity.capital"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  padding: "14px 18px",
                  fontSize: "16px",
                  borderRadius: "12px",
                  border: "2px solid #e0e0e0",
                  transition: "all 0.3s ease",
                  background: "#f8f9fa"
                }}
                onFocus={(e) => e.target.style.border = "2px solid #667eea"}
                onBlur={(e) => e.target.style.border = "2px solid #e0e0e0"}
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label style={{ 
                fontWeight: "600", 
                color: "#333",
                marginBottom: "10px"
              }}>
                Password
              </Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{
                  padding: "14px 18px",
                  fontSize: "16px",
                  borderRadius: "12px",
                  border: "2px solid #e0e0e0",
                  transition: "all 0.3s ease",
                  background: "#f8f9fa"
                }}
                onFocus={(e) => e.target.style.border = "2px solid #667eea"}
                onBlur={(e) => e.target.style.border = "2px solid #e0e0e0"}
              />
            </Form.Group>

            {error && (
              <div style={{
                color: "#d32f2f",
                backgroundColor: "#ffebee",
                padding: "12px",
                borderRadius: "8px",
                marginBottom: "20px",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: "500",
                border: "1px solid #ffcdd2"
              }}>
                {error}
              </div>
            )}

            <Button
              variant="primary"
              type="submit"
              disabled={isLoading}
              style={{
                width: "100%",
                background: isLoading ? "#999" : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                border: "none",
                padding: "16px",
                fontSize: "18px",
                fontWeight: "600",
                borderRadius: "12px",
                boxShadow: "0 8px 20px rgba(102, 126, 234, 0.4)",
                transition: "all 0.3s ease",
                cursor: isLoading ? "not-allowed" : "pointer"
              }}
              onMouseEnter={(e) => !isLoading && (e.target.style.transform = "translateY(-2px)")}
              onMouseLeave={(e) => !isLoading && (e.target.style.transform = "translateY(0)")}
            >
              {isLoading ? (
                <span>
                  <span style={{ 
                    display: "inline-block",
                    width: "20px",
                    height: "20px",
                    border: "3px solid #fff",
                    borderTopColor: "transparent",
                    borderRadius: "50%",
                    animation: "spin 0.8s linear infinite",
                    marginRight: "10px",
                    verticalAlign: "middle"
                  }}></span>
                  Logging in...
                </span>
              ) : "Login to Dashboard"}
            </Button>
          </Form>

          <p style={{
            textAlign: "center",
            marginTop: "30px",
            color: "#999",
            fontSize: "13px"
          }}>
            Secured by Infinnity Capital
          </p>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(10deg); }
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
